import { render, staticRenderFns } from "./KnowledgeCheck.vue?vue&type=template&id=043b43ec"
import script from "./KnowledgeCheck.vue?vue&type=script&lang=js"
export * from "./KnowledgeCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports